 import IndexedDbWrapper from "../../../core/wrappers/browserStorage/indexedDb-wrapper";
 

 export type ReturnDetailFilter = {
  ReturnId: number;
  RMACode: number;
  OrderId: number;
  OrderNumber: string;
  ShippingListId: number;
  ShippingListNo: string;
  CustomerId: number;
  StoreCode:string;
  Status: null;
  StartDate: string;
  EndDate: string;
  Barcodes: string;
  take: number;
  skip: number;
};

 export const initialState = {
  returnDetailFilterInput:{
    ReturnId:0,
    RMACode:0,
    OrderId:0,
    OrderNumber: "",
    ShippingListId: 0,
    ShippingListNo: "",
    CustomerId: 0,
    StoreCode:"",
    Status:null,
    StartDate:"",
    EndDate: "",
     Barcodes: "",
     take: 10,
    skip: 0,
   },
   returnSearchInput:{
     RMACode:0, 
     OrderNumber: "",   
     ShippingListNo:"",
     CargoReturnCode: ""
   },
 
 };

 
 
 export const addToCache = (val:any) =>  { IndexedDbWrapper.addItemToDb("returnRequests", val); }

 

export async function getCachedSearched() {
    let val:any;
    await IndexedDbWrapper.getAllItemFromDb("returnRequests")
      .then((result) => {
        val=result;
      })
      .catch((error) => {
        console.log(error);
        val= null;
      });
      return val;
} 